import { IntlShape } from 'react-intl';
import { CountryData, WIRPhaseTypes } from 'types/wellGuardian';

export const getPhaseName = (intl: IntlShape, phase: string | undefined, countryState: string) => {
  if (countryState === CountryData.denmark) {
    switch (phase) {
      case WIRPhaseTypes.STAGE_GATE_1: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.stageGate1',
        });
      }
      case WIRPhaseTypes.STAGE_GATE_2: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.stageGate2',
        });
      }
      case WIRPhaseTypes.STAGE_GATE_3: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.stageGate3',
        });
      }
      case WIRPhaseTypes.STAGE_GATE_4: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.stageGate4',
        });
      }
      case WIRPhaseTypes.STAGE_GATE_5: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.stageGate5',
        });
      }
      case WIRPhaseTypes.INTERVENTION_COMPLETE: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.interventionCompletePhaseLabel',
        });
      }
      case WIRPhaseTypes.PAUSED_STATE: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.pauseState',
        });
      }
    }
  } else {
    switch (phase) {
      case WIRPhaseTypes.ENGINEERING_WORK:
      case WIRPhaseTypes.CG_ENGINEERING_WORK:
      case WIRPhaseTypes.AG_ENGINEERING_WORK:
      case WIRPhaseTypes.IRAQ_ENGINEERING_WORK:
      case WIRPhaseTypes.ARGENTINA_ENGINEERING_WORK: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.engineeringWorkPhaseLabel',
        });
      }
      case WIRPhaseTypes.KICK_OFF_TECHNICAL_WIR:
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.komTechnicalWirPhaseLabel',
        });
      case WIRPhaseTypes.CG_KICK_OFF_TECHNICAL_WIR: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.scopeValidationPhaseLabel',
        });
      }
      case WIRPhaseTypes.WIR_CREATED:
      case WIRPhaseTypes.CG_WIR_CREATED: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.wirCratedPhaseLabel',
        });
      }
      case WIRPhaseTypes.FINAL_WIR:
      case WIRPhaseTypes.CG_FINAL_WIR:
      case WIRPhaseTypes.AG_FINAL_WIR:
      case WIRPhaseTypes.IRAQ_FINAL_WIR:
      case WIRPhaseTypes.ARGENTINA_FINAL_WIR: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.finalWirPhaseLabel',
        });
      }
      case WIRPhaseTypes.FINAL_PREPARATION:
      case WIRPhaseTypes.NG_FINAL_PREPARATION:
      case WIRPhaseTypes.IRAQ_FINAL_PREPARATION:
      case WIRPhaseTypes.CG_FINAL_PREPARATION:
      case WIRPhaseTypes.AG_FINAL_PREPARATION:
      case WIRPhaseTypes.ARGENTINA_FINAL_PREPARATION: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.finalPreparationPhaseLabel',
        });
      }
      case WIRPhaseTypes.INTERVENTION_CLOSE_OUT:
      case WIRPhaseTypes.NG_INTERVENTION_CLOSE_OUT:
      case WIRPhaseTypes.IRAQ_INTERVENTION_CLOSE_OUT:
      case WIRPhaseTypes.CG_INTERVENTION_CLOSE_OUT:
      case WIRPhaseTypes.AG_INTERVENTION_CLOSE_OUT:
      case WIRPhaseTypes.ARGENTINA_INTERVENTION_CLOSE_OUT: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.interventionCloseoutPhaseLabel',
        });
      }
      case WIRPhaseTypes.INTERVENTION_OPERATION:
      case WIRPhaseTypes.NG_INTERVENTION_OPERATION:
      case WIRPhaseTypes.IRAQ_INTERVENTION_OPERATION:
      case WIRPhaseTypes.CG_INTERVENTION_OPERATION:
      case WIRPhaseTypes.AG_INTERVENTION_OPERATION:
      case WIRPhaseTypes.ARGENTINA_INTERVENTION_OPERATION: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.interventionOperationPhaseLabel',
        });
      }
      case WIRPhaseTypes.INTERVENTION_COMPLETE: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.interventionCompletePhaseLabel',
        });
      }
      case WIRPhaseTypes.REACTIVE_SCOPE: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.reactiveScopeLabel',
        });
      }
      case WIRPhaseTypes.PAUSED_STATE: {
        return intl.formatMessage({
          id: 'wellGuardian.wir.wirCreation.pauseState',
        });
      }
    }
  }
};
